module.exports = __webpack_public_path__ + "static/media/Artwork.04c2cf8f.png";